export const triggerClick = function (elem) {
	const evt = new MouseEvent('click', {
		bubbles: true,
		cancelable: true,
		view: window,
	})
	//eslint-disable-next-line
	let canceled = !elem.dispatchEvent(evt)
}

export const getMenuQuery = (search) => {
	const params = new URLSearchParams(search)
	return { menuId: params.get('menu'), dmaId: params.get('dma') }
}

export const buildMenuSearch = ({ menuId, dmaId } = {}) => {
	const params = new URLSearchParams()
	if (menuId) params.set('menu', menuId)
	if (dmaId) params.set('dma', dmaId)
	const search = params.toString()
	return search ? `?${search}` : ''
}
